module.exports = __webpack_public_path__ + "static/media/notepad.93bda932.png";